import { ApplicationUrls } from 'src/app/configuration/application-urls';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationLoaderService extends ApplicationUrls {

  constructor(private http: HttpClient) {
    super();
  }

  configure(): void {
    this.http.get<ApplicationUrls>(`${environment.API_BASE_URL}/config`)
      .pipe(first())
      .toPromise()
      .then(data => {
        this.MerchantAppLink = data.MerchantAppLink;
        this.BGVerificationAppLink = data.BGVerificationAppLink;
        this.ContosoUniLink = data.ContosoUniLink;
      }).catch((err) => {
        console.error('Config load failed', err);
      });
  }

}
